// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"750d81e6","239":"e7f9bde9","455":"ff36a38f","889":"8071dc98"}[chunkId] + ".chunk.js";
};